'use client'
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";

export default function Hero() {
  const pathname = usePathname()

  console.log('pathname', pathname)

  return (
    <div className="slider-area slider-style-1 bg-transparent banner-company height-750">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-7 col-xl-6 order-2 order-lg-1 mt_md--40 mt_sm--40">
            <div className="inner text-left">
              <span className="subtitle">Vi skreddersyr styresystemer til dine behov</span>
              <h1 className="title theme-gradient display-one">
                SB Tech AS
              </h1>
              <ul className="list-icon">
                <li>
                  <span className="icon">
                    <i className="feather-check" />
                  </span>
                  Mer enn 50 års erfaring
                </li>
                <li>
                  <span className="icon">
                    <i className="feather-check" />
                  </span>
                  Kjernekompetanse i design og utvikling
                </li>
                <li>
                  <span className="icon">
                    <i className="feather-check" />
                  </span>
                  Din foretrukne samarbeidspartner
                </li>
              </ul>
              <div className="button-group mt--40">
                {pathname !== '/company/company/about' && (
                  <a
                    className="btn-default btn-medium round btn-icon"
                    href="/company/company/about"
                  >
                    Les mer <i className="icon feather-arrow-right" />
                  </a>
                )}
                <Link
                  className="btn-default btn-medium btn-border round btn-icon"
                  href={`/company/company/contact`}
                >
                  Kontakt oss <i className="icon feather-arrow-right" />
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-5 col-xl-6 order-1 order-lg-2">
            <div className="frame-image">
              <Image
                alt="Banner Images"
                src="/images/billy-freeman-nkxB5Ab-ONY-unsplash.jpg"
                width={590}
                height={394}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
